/////////////////////////////////////////////
/////////////Slick Partners/////////////////
///////////////////////////////////////////
$('.slick-partners').bxSlider({
    slideWidth: 130,
    slideMargin: 0,
    minSlides: 1,
    maxSlides: 10,
    pager: false,
    auto: true,
    captions: false,
    controls: false,
    moveSlides: 1
});